import {ZipArchive} from "../../types/types";
import * as React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {Link, useTheme} from "@mui/material";
import {getAssetDownloadUrl} from "../../common/helpers";
import {StyledButton} from "../Common/StyledButton";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface DownloadMenuProps {
    items?: {
        [k: string]: ZipArchive,
    },
    label: string,
    locale: string
}

const DownloadMenu = ({items, label, locale}: DownloadMenuProps) => {
    
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [calculatedWidth, setCalculatedWidth] = React.useState(0);

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const isOpen = anchorEl !== null;
    
    const theme = useTheme();

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setCalculatedWidth(event.currentTarget && event.currentTarget.offsetWidth);
    };

    if (!items || Object.keys(items).length === 0) {
        return null;
    }

    return <Box sx={{flexGrow: 0, ml: "auto"}}>
        <StyledButton
            disableRipple
            aria-controls={isOpen ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={isOpen ? "true" : undefined}
            onClick={handleOpenMenu}
            variant="contained"
            endIcon={isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        >
            {label}
        </StyledButton>
        <Menu
            sx={{mt: "45px", minWidth: anchorEl && anchorEl.offsetWidth }}
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
        >
            {Object.keys(items).map((key) => (
                <MenuItem key={key} sx={{minWidth: `${calculatedWidth}px` }}>
                    <Link href={getAssetDownloadUrl(items[key].path!)}
                          sx={{ color: theme.palette.text.secondary }}
                          underline="none">
                        {items[key].labels?.[locale] || items[key].labels?.["en-US"]}
                    </Link>
                </MenuItem>
            ))}
        </Menu>
    </Box>
}

export default DownloadMenu;